import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "16px",
    height: "42px",
  },
  actions: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
  },
  iconButton: {
    width: "42px",
    height: "42px",
    padding: 0,
  },
  optionRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    width: "100%",
    gap: "10px",
  },
  activeBadge: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    height: "26px",
    boxSizing: "border-box",
    backgroundColor: theme.palette.success.main,
    color: theme.palette.common.white,
    borderRadius: "4px",
    padding: "0 14px",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "21px",
    whiteSpace: "nowrap",
    fontFamily: "Noto Sans Hebrew",
  },
  inactiveBadge: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    height: "26px",
    boxSizing: "border-box",
    backgroundColor: theme.palette.grey[500],
    color: theme.palette.common.white,
    borderRadius: "4px",
    padding: "0 14px",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "21px",
    whiteSpace: "nowrap",
    fontFamily: "Noto Sans Hebrew",
  },
  optionLabel: {
    display: "inline-flex",
    alignItems: "center",
    height: "26px",
    boxSizing: "border-box",
    padding: "0 14px",
    fontFamily: "Noto Sans Hebrew",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "21px",
    color: theme.palette.secondary.main,
  },
  checkbox: {
    color: `${theme.palette.primary.main} !important`,
    flexShrink: 0,
    "&.Mui-checked": {
      color: `${theme.palette.primary.main} !important`,
    },
  },
}));
